import { API } from "aws-amplify";
import axios from "axios";

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === "true";
const baseURL = process.env.REACT_APP_APIURL;

const call = async (method: "get" | "post" | "put" | "patch" | "del", path: string, body?: any, params?: any) => {
  if (isLocalAuth) {
    const response = await axios({
      method: method === "del" ? "delete" : method,
      url: `${baseURL}${path}`,
      data: body,
      params,
    });
    return response.data;
  }
  if (method === "get") return API.get("Backend", path, params ? { queryStringParameters: params } : {});
  if (method === "del") return API.del("Backend", path, params ? { queryStringParameters: params } : {});
  if (method === "post") return API.post("Backend", path, body ? { body } : {});
  if (method === "put") return API.put("Backend", path, body ? { body } : {});
  return API.patch("Backend", path, body ? { body } : {});
};

export async function fetchAgent() {
  return call("get", "/ai/agent");
}

export async function saveAgent(payload: any) {
  return call("put", "/ai/agent", payload);
}

export async function saveAgentExample(payload: any) {
  return call("post", "/ai/agent/examples", payload);
}

export async function runAgentTest(payload: any) {
  return call("post", "/ai/agent/test", payload);
}

export async function fetchInboxMessages() {
  return call("get", "/ai/inbox/messages");
}

export async function fetchDrafts(status?: string) {
  return call("get", "/ai/drafts", undefined, status ? { status } : undefined);
}

export async function fetchDraftStats() {
  return call("get", "/ai/drafts/stats");
}

export async function requestDraftGeneration(payload: any) {
  return call("post", "/ai/drafts/generate", payload);
}

export async function patchDraft(id: string, body: string) {
  return call("patch", `/ai/drafts/${id}`, { body });
}

export async function postDraftDecision(id: string, action: string, body?: string) {
  return call("post", `/ai/drafts/${id}/decide`, { action, body });
}

export async function postDraftSend(id: string) {
  return call("post", `/ai/drafts/${id}/send`);
}

export async function startMailboxWatch() {
  return call("post", "/ai/inbox/watch");
}

export async function stopMailboxWatch() {
  return call("del", "/ai/inbox/watch");
}

export async function fetchAvatars() {
  return call("get", "/ai/avatars");
}

export async function postAvatar(payload: any) {
  return call("post", "/ai/avatars", payload);
}

export async function fetchAvatar(id: string) {
  return call("get", `/ai/avatars/${id}`);
}

export async function postAvatarConsent(id: string) {
  return call("post", `/ai/avatars/${id}/consent`);
}

export async function postDefaultAvatar(id: string) {
  return call("post", `/ai/avatars/${id}/default`);
}

export async function removeAvatar(id: string) {
  return call("del", `/ai/avatars/${id}`);
}

export async function postDraftVideo(id: string, payload?: any) {
  return call("post", `/ai/drafts/${id}/video`, payload);
}
